import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a6ec8dc0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a6ec8dc0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ec8dc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6ec8dc0')) {
      api.createRecord('a6ec8dc0', component.options)
    } else {
      api.reload('a6ec8dc0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a6ec8dc0&scoped=true", function () {
      api.rerender('a6ec8dc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/login/index.vue"
export default component.exports